<template>
    <div class="card testing-history" v-if="data">
        <div class="card-header">
            <label class="card-title">ATT Testing History</label>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <div class="d-flex border rounded mb-2">
                    <div v-for="event in historyEvents" class="w-100 border-right">
                        <div style="min-height: 40px;" class="text-center w-100 px-2 px-1 d-flex align-items-center justify-content-center" :class="{'bg-success':event.is_project, 'bg-danger':!event.is_project}">
                            <div class="text-white font-weight-bolder text-sm text-uppercase" v-text="event.name"></div>
                        </div>
                        <div class="px-2 py-3 text-sm">
                            <div v-text="shortDate(event.date)"></div>
                            <div v-text="event.data.city ? 'City of '+ event.data.city : ''"></div>
                            <div v-if="event.is_project">
                                <a :href="`/projects/${event.data.slug}`" target="_blank">
                                    <div class="text-info"># <span v-text="event.data.number"></span></div>
                                </a>
                                <div class="text-muted" v-text="event.data.name"></div>
                                <div v-if="haveDaylightTest(event.data)">
                                    <b class="text-bluelight">Using Daylight Test</b>
                                </div>
                            </div>
                            <div v-else>
                                <a :href="`/field-inspections/${event.data.number}`" target="_blank">
                                    <div class="text-info"># <span v-text="event.data.number"></span></div>
                                </a>
                                <div class="text-muted" v-text="event.data.trigger"></div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-2" v-if="authorize('admin')">
                <a href="#" @click="showProjects()" class="btn-sm btn-link ml-auto mb-0">
                    Show ATT Projects
                </a>
            </div>
        </div>
    </div>
</template>
<script>

let TestingHistory = require('@/mixins/TestingHistory')

export default {

    mixins: [TestingHistory],

    methods: {
        showProjects() {
            var request = Storage.get(App.config.userProjectsKey)
            if (!request) request = {}
            request.energy_code = ''
            request.with = ''
            request.query = ''
            request.page = 1
            request.user_id = this.technician.id
            Storage.set(App.config.userProjectsKey, request)
            this.redirectTo('/projects', '_blank')
        },
    }
}
</script>
